
export { RecordLinkModule } from './record-link.module';